export default "/react/hybridIcon-da3ba4a3.svg";